module.exports = __webpack_public_path__ + "img/pn.c381ab4a.svg";